import { AlertService } from '../../shared/services/alert.service';
import { OnInit } from '@angular/core';
import { ScaleRange } from '../../shared/models/scale-range';
import { AssessmentService } from '../../shared/services/assessment.service';
import { Router, ActivatedRoute } from '@angular/router';
var ScaleRangeEditComponent = /** @class */ (function () {
    function ScaleRangeEditComponent(assessmentService, alertService, router, route) {
        this.assessmentService = assessmentService;
        this.alertService = alertService;
        this.router = router;
        this.route = route;
        this.SAVE_TIME = 1500;
        this.ERROR_MESSAGE_TIME = 3000;
        this.range = this.getNewObject();
    }
    ScaleRangeEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            var assessmentUid = params['uid'];
            var scaleId = params['scaleId'];
            var rangeId = params['rangeId'];
            _this.assessmentService.getAssessment(assessmentUid)
                .then(function (assessment) {
                _this.assessment = assessment;
                _this.scale = assessment.scales.find(function (s) { return s.id == scaleId; });
                _this.range = (_this.scale) ? _this.scale.ranges.find(function (r) { return r.id == rangeId; }) : null;
                if (!(_this.scale && _this.range)) {
                    // TODO: stephen should we navigate back?? or do some kind of 404?
                    _this.router.navigate(["not-found"]);
                }
            })
                .catch(function (error) {
                console.error(error);
                _this.router.navigate(["not-found"]);
            });
        });
    };
    ScaleRangeEditComponent.prototype.getNewObject = function () {
        var obj = new ScaleRange();
        obj.id = this.assessmentService.newId();
        return obj;
    };
    Object.defineProperty(ScaleRangeEditComponent.prototype, "range", {
        get: function () {
            return this._range;
        },
        set: function (v) {
            this._range = v;
        },
        enumerable: true,
        configurable: true
    });
    ScaleRangeEditComponent.prototype.saveRange = function (range) {
        var _this = this;
        this.isSaving = true;
        return this.assessmentService.saveAssessment(this.assessment).then(function (assessment) {
            _this.alertService.success("Range saved", _this.SAVE_TIME);
            _this.isSaving = false;
            return range;
        }).catch(function (error) {
            _this.isSaving = false;
            _this.alertService.error("An error occurred in saving. Please try again or contact support.", _this.ERROR_MESSAGE_TIME);
            console.error(error);
        });
    };
    ScaleRangeEditComponent.prototype.save = function () {
        this.saveRange(this.range);
    };
    ScaleRangeEditComponent.prototype.saveAndCreateNew = function () {
        var _this = this;
        this.saveRange(this.range).then(function (question) {
            // TODO: stephen for whatever reason this isn't working very well here...
            _this.router.navigate(["../../", "new"], { relativeTo: _this.route, replaceUrl: true });
            // this.router.navigate(["admin","assessment",this.assessment.uid, "edit"
            //     ,"scale", this.scale.id, "edit"
            //     , "scale-range", "new"], {replaceUrl: true});
        });
    };
    return ScaleRangeEditComponent;
}());
export { ScaleRangeEditComponent };



// WEBPACK FOOTER //
// ./src/app/admin/scale-range-edit/scale-range-edit.component.ts.pre-build-optimizer.js